module.exports = __webpack_public_path__ + "media/images/swifticons/pulsesurveysetup-401ac32faa606887313816e7be765575.svg";